import { Bitmask, Color, createBitmask } from 'utils';

export interface TObject {
  id: string;
  name?: string;
  colorRgb?: Color;
  categoryId?: string;
}

export const ObjectEnum = createBitmask([
  'monitor',
  'sticker',
  'light',
  'door',
  'person'
]);
export type ObjectEnumValue = Bitmask<typeof ObjectEnum>;
